import i18n from "../../../../Utils/i18next/i18next";
import { NotificationManager } from "react-notifications";
import { cloneDeep } from "lodash";
import { GlobalAuthFetch } from "../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import moment from "moment/moment";

const { t } = i18n;

export const onSubmit = async (values, props, setResults, setOfferResults) => {
  const data = cloneDeep(values);

  const workerUUID = data.worker.value;
  const reportStartDate = new Date(data.reportStartDate).toISOString();
  const reportEndDate = new Date(data.reportEndDate).toISOString();

  // API
  const res = await GlobalAuthFetch({
    path: `/crm/calculateCrmEventsStatistic/${workerUUID}/${reportStartDate}/${reportEndDate}`,
    method: "GET",
    data,
  });
  const payload = res.payload;
  if (payload.status === 200) {
    props.setErrorHeader(0, false);
    setResults([
      { type: "EMAIL", result: payload.data.EMAIL },
      { type: "PHONE", result: payload.data.PHONE },
      { type: "MEET", result: payload.data.MEET },
      { type: "MEET_ONLINE", result: payload.data.MEET_ONLINE },
      // { type: "VISIT_BANK", result: payload.data.VISIT_BANK },
    ]);
    setOfferResults([
      { type: "WIN", result: payload.data.WIN },
      { type: "LOSS", result: payload.data.LOSS },
    ]);

    NotificationManager.success(i18n.t("global:crm.fetchedReport"));
  }
};

export const onValidate = (values, props) => {
  const { update, isSubmit, steps } = props;
  const errors = {};

  if (!values.worker) {
    errors.worker = t("global:crm.errors.worker");
  }
  if (!values.reportStartDate) {
    errors.reportStartDate = t("global:crm.errors.reportStartDate");
  }
  if (!values.reportEndDate) {
    errors.reportEndDate = t("global:crm.errors.reportEndDate");
  }

  if (moment(values.reportStartDate).isAfter(moment(values.reportEndDate))) {
    errors.reportStartDate = t("global:crm.errors.startDateAfterEndDate");
  }
  if (moment(values.reportEndDate).isBefore(moment(values.reportStartDate))) {
    errors.reportEndDate = t("global:crm.errors.endDateBeforeStartDate");
  }

  if (!steps[0]?.error && isSubmit && Object.keys(errors).length > 0) {
    props.setErrorHeader(0, true);
  }
  if (steps[0]?.error && !isSubmit && Object.keys(errors).length <= 0) {
    props.setErrorHeader(0, false);
  }

  return errors;
};
